'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00247 from "./presto.-Presto$$anon$7.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$6() {
  this.bc2 = null;
  this.bbU = null;
  this.bbV = false;
  this.bc3 = null;
  this.bc4 = false;
  this.bc7 = null;
  this.bc0 = null;
  this.bc1 = false;
  this.bbW = null;
  this.bbX = false;
  this.bbY = null;
  this.bbZ = false;
  this.bc5 = false;
  this.bc6 = false;
  this.bc2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bc7 = "CompactGroup";
}
export { $c_Lpresto_Presto$$anon$6 as $c_Lpresto_Presto$$anon$6 };
$p = $c_Lpresto_Presto$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$6;
/** @constructor */
function $h_Lpresto_Presto$$anon$6() {
}
export { $h_Lpresto_Presto$$anon$6 as $h_Lpresto_Presto$$anon$6 };
$h_Lpresto_Presto$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bc2;
});
$p.L = (function() {
  if ((!this.bbV)) {
    this.bbU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bbV = true;
  }
  return this.bbU;
});
$p.O = (function() {
  if ((!this.bc4)) {
    this.bc3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bc4 = true;
  }
  return this.bc3;
});
$p.E = (function() {
  return this.bc7;
});
$p.t = (function() {
  if ((!this.bc1)) {
    this.bc0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bc1 = true;
  }
  return this.bc0;
});
$p.M = (function() {
  if ((!this.bbX)) {
    this.bbW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bbX = true;
  }
  return this.bbW;
});
$p.Q = (function() {
  if ((!this.bbZ)) {
    this.bbY = new $j_presto$002e$002dPresto$0024$0024anon$00247.$c_Lpresto_Presto$$anon$7();
    this.bbZ = true;
  }
  return this.bbY;
});
$p.w = (function() {
  if ((!this.bc6)) {
    this.bc5 = false;
    this.bc6 = true;
  }
  return this.bc5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee50) => ((p) => \u03b4scrutinee50.ad6(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_Presto$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$6, "presto.Presto$$anon$6", ({
  Ng: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$6 as $d_Lpresto_Presto$$anon$6 };
//# sourceMappingURL=presto.-Presto$$anon$6.js.map
